/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RegisteredDeviceResponse } from '../../models/registered-device-response';

export interface GetDevice$Params {
  customerId?: number;
  facilityGroupId?: number;
  includeNonActive?: boolean;
}

export function getDevice(http: HttpClient, rootUrl: string, params?: GetDevice$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RegisteredDeviceResponse>>> {
  const rb = new RequestBuilder(rootUrl, getDevice.PATH, 'get');
  if (params) {
    rb.query('customerId', params.customerId, {});
    rb.query('facilityGroupId', params.facilityGroupId, {});
    rb.query('includeNonActive', params.includeNonActive, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RegisteredDeviceResponse>>;
    })
  );
}

getDevice.PATH = '/api/regdevice';
